import flatpickr from 'flatpickr';
import money from 'v-money';
import VueTheMask from 'vue-the-mask';
import * as VueGoogleMaps from "vue2-google-maps";

const _popGet = (value, path, defaultValue) => {
  return String(path).split('.').reduce((acc, v) => {
    try {
      acc = acc[v]
    } catch (e) {
      return defaultValue
    }
    return acc
  }, value)
}

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Vue = require('vue');
Vue.component('main-nav', require('./components/site/MainNav.vue').default);
Vue.component('action-icons', require('./components/common/ActionIcons.vue').default);
Vue.component('rate-stars', require('./components/common/RateStars.vue').default);
Vue.component('product-images-gallery', require('./components/site/ProductImagesGallery.vue').default);
Vue.component('the-modal', require('./components/common/TheModal.vue').default);
Vue.component('add-to-wishlist', require('./components/site/AddToWishlist.vue').default);
Vue.component('site-quick-search', require('./components/site/SiteQuickSearch.vue').default);
Vue.component('home-banner', require('./components/site/HomeBanner.vue').default);
Vue.component('chat-buttons', require('./components/site/ChatButtons.vue').default);

Vue.component('popup-component', require('./components/site/PopupComponent.vue').default);
Vue.component('branches-component', require('./components/site/BranchesComponent.vue').default);
Vue.component('geographics-fields', require('./components/site/GeographicsFields.vue').default);
Vue.component('geographics-fields-shipping', require('./components/site/GeographicsFieldsShipping.vue').default);
Vue.component('slider-switch', require('./components/common/SliderSwitch.vue').default);
Vue.component('collapsable-component', require('./components/common/CollapsableComponent.vue').default);
Vue.component('taxcredit-fields', require('./components/site/TaxcreditFields.vue').default);
Vue.component('checkout-summary', require('./components/site/CheckoutSummary.vue').default);
Vue.component('checkout-wizard', require('./components/site/CheckoutWizard.vue').default);
Vue.component('checkout-dispatch', require('./components/site/CheckoutDispatch.vue').default);
Vue.component('configurable-options', require('./components/site/ConfigurableOptions.vue').default);
Vue.component('checkout-payment-methods', require('./components/site/CheckoutPaymentMethods.vue').default);
Vue.component('checkout-cc', require('./components/site/CheckoutCc.vue').default);

Vue.component('compare-product', require('./components/site/CompareProduct.vue').default);
Vue.component('compare-products-list', require('./components/site/CompareProductsList.vue').default);

Vue.use(VueTheMask);
Vue.use(money);

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyBla-r4JhM_U6k4sykUbsybGg8WGtBFTyw',
    key: 'AIzaSyDnKTGGLnRTzDCxfpOncrZX6UO6wXwmC1E',
  }
});

Vue.prototype.trans = string => _popGet(window.i18n, string);

const app = new Vue({
  el: '#app',
});

flatpickr.localize(require('flatpickr/dist/l10n/es.js').default.es);